// The /support page (#402). The server renders the same copy for readers without JavaScript,
// through scripts/export-seo-content.mjs, so it lives here rather than in the page.
// The answers are the landing page FAQ's and the refund policy's, not new promises.
export const SUPPORT_PAGE = {
    lastUpdated: "October 21, 2026",
    email: "support@stockmaid.com",
    include:
        "It helps to include the page you were on, what you expected to happen, and what happened instead. If it involves the extension, the version number from chrome://extensions saves a round trip.",
    questions: [
        {
            question: "Can I use StockMaid for free?",
            answer:
                "Yes. Free Discord notifications tell you when a product is available in-store or online. Premium adds detailed email alerts and the ZIP codes of the Best Buy stores holding stock."
        },
        {
            question: "How do I cancel Premium?",
            answer:
                "Cancel anytime from your Profile page. Cancelling stops future charges, and you keep Premium until the end of your current billing period."
        },
        {
            question: "Can I get a refund?",
            answer:
                "First-time subscribers can ask for a full refund within 7 days of their first payment. Write to us from the email address on your account and say briefly why. The Refund Policy has the details."
        }
    ]
};
